import { render, staticRenderFns } from "./eventPrize.vue?vue&type=template&id=67707697&scoped=true&"
import script from "./eventPrize.vue?vue&type=script&lang=js&"
export * from "./eventPrize.vue?vue&type=script&lang=js&"
import style0 from "./eventPrize.vue?vue&type=style&index=0&id=67707697&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67707697",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VImg,VProgressCircular})
